





























import { Component, Vue, Prop } from 'vue-property-decorator';
import EditOnClickField from '@/components/util/EditOnClickField.vue';
import { FieldMetadata } from 'private_modules/performo-api/dist/models';
import { WorkordersApi } from 'private_modules/performo-api/dist';
import { mapGetters } from 'vuex';

@Component({
  components: { EditOnClickField },
  computed: mapGetters({
    ordersApi: 'ordersApi'
  })
})
export default class ExtendedDataEditor extends Vue {
  @Prop({ required: true, default: [] })
  private metadata!: FieldMetadata[];

  @Prop({ required: true, type: String, default: '' })
  private workorderId!: string;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Prop({ required: true })
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private value!: { [key: string]: any };

  @Prop({ required: false, default: true })
  private canEdit!: boolean;

  private ordersApi!: WorkordersApi;
  private extendedDataMode = 'read';

  private async handleExtendedDataChange(name: string, extendedData: string) {
    // perform api call
    try {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const newExtendedData: { [key: string]: any } = {
        ...this.value,
        [name]: extendedData
      };

      await this.ordersApi
        .changeExtendedData({
          workorderId: this.workorderId,
          changeOrderExtendedDataCommand: {
            newExtendedData: newExtendedData
          }
        })
        .then(() => {
          this.$emit('extended-data-handler');
          this.$emit('input');
        });
    } catch (error) {
      this.$emit('error', error);
    }
    this.exitEdit();
  }

  private exitEdit() {
    // revert to display mode
    this.extendedDataMode = 'read';
  }
}
